/**
 * Created by Owlz on 23/09/2018.
 */
export default class Scene extends PIXI.Container {
    constructor() {
        super();
        this.app = null;
    }

    start() {
    }

    update(dt) {
    }

    resize() {
    }
}